import en from './en';
import fr from './fr';

const translations = {
  en,
  fr,
};

export default translations;
